/**
 * 路由Category分类表:
 *     各navtype模块分类包含的一级路由
 *
 * type说明:
 *       CATEGORY - navtype模块分类
 *       LIST     - 菜单分类，无实际对应的路由
 *       MENU     - 实际的页面
 */

const routerCategoryMap = {
    Homepage: [
        'Homepage',
    ],
    // CATEGORY - navtype模块分类
    Product: [
        // LIST - 菜单分类，无实际对应的路由
        'Appointment',
        'CollisionRescue',
        'Maintain',
    ],
    CustomerService: [
        'ArriveRemind',
    ],
    // OnlineMall: [
    //     'ShopManage',
    //     'Devise',
    //     'Create',
    //     'Read',
    // ],
    Customers: [
        'Customers',
    ],
    Settings: [
        'Settings',
    ],
    MarketManage: [
        'Coupon',
        'Activity',
        'Advertisement',
    ],
    BusinessData: [
        'FrequentLocations',
        'RadiationVehicles',
    ],
    StoreManage: [
        'StoreManage',
    ],
    Feedback: [
        'Feedback',
    ],
};

export default routerCategoryMap;
